document.addEventListener('DOMContentLoaded', () => {
  const membershipHandles = [
    'ultimate-ascension-guide-pro',
    'ultimate-ascension-guide-ultimate'
  ];

  const isMembershipHandle = (handle) =>
    membershipHandles.includes(handle);

  /*
   * Prevent adding a membership if ANY membership
   * is already in the cart.
   */
  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;

      if (!form.action || !form.action.includes('/cart/add')) {
        return;
      }

      const formData = new FormData(form);
      const variantId = formData.get('id');

      if (!variantId) return;

      /*
       * Stop Shopify's normal add-to-cart immediately.
       * This prevents the duplicate from appearing first.
       */
      event.preventDefault();
      event.stopImmediatePropagation();

      try {
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        const existingMembership = cart.items.find((item) =>
          isMembershipHandle(item.handle)
        );

if (existingMembership) {
  const popup = document.createElement('div');

  popup.innerHTML = `
    <div style="
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.75);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 999999;
      padding: 20px;
    ">
      <div style="
        position: relative;
        width: 100%;
        max-width: 430px;
        background: #161616;
        color: #ffffff;
        padding: 40px 30px;
        border-radius: 16px;
        text-align: center;
        box-shadow: 0 20px 60px rgba(0,0,0,0.5);
      ">

        <button
          type="button"
          id="ua-popup-close"
          style="
            position: absolute;
            top: 12px;
            right: 16px;
            background: none;
            border: none;
            color: #ffffff;
            font-size: 28px;
            cursor: pointer;
          "
        >×</button>

        <div style="
          width: 50px;
          height: 50px;
          margin: 0 auto 20px;
          background: #D5FF3F;
          color: #0B0B0B;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          font-weight: 700;
        ">✓</div>

        <h2 style="
          margin: 0 0 14px;
          color: #ffffff;
          font-size: 24px;
        ">
          Membership Already Added
        </h2>

        <p style="
          margin: 0 0 10px;
          color: #ffffff;
          font-size: 16px;
          line-height: 1.5;
        ">
          You already have an Ultimate Ascension membership in your basket.
        </p>

        <p style="
          margin: 0 0 25px;
          color: #C4C4C4;
          font-size: 14px;
        ">
          You can only purchase one membership at a time.
        </p>

        <a
          href="/cart"
          style="
            display: block;
            padding: 14px;
            background: #D5FF3F;
            color: #0B0B0B;
            border-radius: 8px;
            text-decoration: none;
            font-weight: 700;
            margin-bottom: 10px;
          "
        >
          View Basket
        </a>

        <button
          type="button"
          id="ua-popup-continue"
          style="
            width: 100%;
            padding: 14px;
            background: transparent;
            color: #ffffff;
            border: 1px solid rgba(255,255,255,0.2);
            border-radius: 8px;
            font-weight: 700;
            cursor: pointer;
          "
        >
          Continue Shopping
        </button>

      </div>
    </div>
  `;

  document.body.appendChild(popup);

  const overlay = popup.firstElementChild;

  popup.querySelector('#ua-popup-close').onclick = () => {
    popup.remove();
  };

  popup.querySelector('#ua-popup-continue').onclick = () => {
    popup.remove();
  };

  overlay.onclick = (event) => {
    if (event.target === overlay) {
      popup.remove();
    }
  };

  return;
}

        /*
         * No membership exists, so add the product normally.
         */
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (!addResponse.ok) {
          throw new Error('Unable to add membership.');
        }

        /*
         * Refresh so Shopify's cart reflects the new membership.
         */
        window.location.href = '/cart';

      } catch (error) {
        console.error('Membership check failed:', error);
      }
    },
    true
  );

  /*
   * Keep membership quantity at 1
   * and hide quantity controls.
   */
  const limitMembershipQuantities = () => {
    document.querySelectorAll('.cart-item').forEach((item) => {
      const title = item.querySelector('.cart-item__name');

      if (!title) return;

      const url = title.getAttribute('href') || '';

      const isMembership = membershipHandles.some((handle) =>
        url.includes(handle)
      );

      if (!isMembership) return;

      const quantityInput = item.querySelector('.quantity__input');

      if (quantityInput) {
        quantityInput.max = '1';

        if (parseInt(quantityInput.value, 10) > 1) {
          quantityInput.value = '1';
        }
      }

      const quantityControls =
        item.querySelector('.quantity.cart-quantity');

      if (quantityControls) {
        quantityControls.style.display = 'none';
      }
    });
  };

  limitMembershipQuantities();

  document.addEventListener('cart:updated', limitMembershipQuantities);
});